import type { ReactNode } from 'react';
import { cn } from '@shared/utils';
import { LABEL_CLASS } from '../classes';

export interface SectionProps {
  title: string;
  /** 標題下方、內容之前：說明這一區是什麼、套用到哪裡 */
  description?: ReactNode;
  /** 內容之後的附註：選了之後會怎樣、記在哪裡 */
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** 設定頁、表單裡的一個分區：小標籤、內容，以及選填的說明與附註。 */
export function Section({
  title,
  description,
  hint,
  children,
  className,
}: SectionProps) {
  return (
    <section className={cn('flex flex-col gap-2', className)}>
      <h2 className={LABEL_CLASS}>{title}</h2>
      {description && (
        <p className="text-xs leading-relaxed text-muted-foreground">
          {description}
        </p>
      )}
      {children}
      {hint && (
        <p className="text-xs leading-relaxed text-muted-foreground">{hint}</p>
      )}
    </section>
  );
}
